export const NAME_LABEL = 'Name';
export const SUBMIT_BUTTON_LABEL = 'Join chat';
export const FORM_TITLE = 'Pick a name';
